import React, { useEffect, useState } from "react";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment, { isDate } from 'moment';
import { useTranslation } from 'react-i18next';
import XLSX from "xlsx";
import { Table, Button, Search, IconDownload, Modal, TextBox, RadioButtons, RadioButton, Select, DatePicker, FilePicker, InlineNotification } from "@veneer/core";
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";
import $ from 'jquery';

const PriceProtectionView = (props) => {
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [loadingData, setLoadingData] = useState(true);
    const [dataPriceProtection, setDataPriceProtection] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [optionVal, setOptionVal] = useState("0");
    const [dataPriceProtectionList, setDataPriceProtectionList] = useState([]);
    const [channelList, setChannelList] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState([]);
    const [endUserList, setEndUserList] = useState([]);
    const [selectedEndUser, setSelectedEndUser] = useState([]);
    const [pressList, setPressList] = useState([]);
    const [selectedPress, setSelectedPress] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [discount, setDiscount] = useState();
    const [file, setFile]=useState('');
    const [reloadView, setReloadView] = useState(0);
    
    useEffect(() => {
        /*/validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate*/

        const dataResponseLoad = (status, data) => {
            data['dataPP'].forEach(x => {
                x.startDate = moment(x.startDate).format("MMM/YYYY");
                x.endDate = moment(x.endDate).format("MMM/YYYY");
            });
            setDataPriceProtection(data['dataPP']);

            setDataPriceProtectionList(data['dataListPP']);
            setChannelList([...new Map(data['dataListPP'].map(x => [x.idCustomer, x.customerName]) )].map(x => ({ value: x[0], label: x[1] })));

            setLoadingData(false);
        }

        const fetchData = async () => {
            connectApi.get( "api/Channels/PriceProtection", '', dataResponseLoad )
            .catch( (error) => {
                setLoadingData(false);
                Swal.fire( "Error " + error.response, error.response, "error" );
            });
        };
        
        fetchData();
    },[reloadView] );
    
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if ( orderBy === "idPress" ){
            let bS = bSort + "";
            let aS = aSort + "";
            if (parseInt(bS.replaceAll(',','')) < parseInt(aS.replaceAll(',',''))) 
                return -1;
            if (parseInt(bS.replaceAll(',','')) > parseInt(aS.replaceAll(',','')))
                return 1;
        } else if ( orderBy === "startDate" || orderBy === "endDate"  ) {
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else if (orderBy === "discount") {
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } 
        return 0;
    }

    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
        });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending') ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    const fetchEndUsers = (idChannel) => {
        setEndUserList([...new Map(dataPriceProtectionList.filter(x => x.idCustomer == idChannel).map(x => [x.idEndUser, x.endUserName]) )].map(x => ({ value: x[0], label: x[1] })));
    };

    const fetchPressList = (idEndUser) => {
        setPressList(dataPriceProtectionList.filter(x => x.idEndUser == idEndUser && x.idCustomer == selectedChannel[0]).flatMap(x => x.idPressList).map(x => ({ value: x, label: x })));
    }
    const handleOnDateChange = (newDates) => {
        const { startDate: newStartDate, endDate: newEndDate } = newDates;
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    function submitFile (typeSubmit) {
        let data = new FormData();
        data.append("Action", typeSubmit);

        if ( typeSubmit == 'oneToOne') {
            if ( selectedPress.length <= 0 ) {
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyWrongValues") + ": " + t("pressid")
                });
                setShowNotification(true);
            } else if ( discount <= 0 || isNaN(discount) ) {
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyNegativeOrCero") + ": " + t("discount")
                });
                setShowNotification(true);
            } else if ( new Date(endDate) <= new Date(startDate) ){
                setNotificationDetails({
                    title: t("notifyWrongDate"),
                    type: 'negative',
                    description: t("notifyWrongDate")
                });
                setShowNotification(true);
            } else {
                data.append("idPress", selectedPress);
                data.append("Discount", discount);
                data.append("StartDate", moment(new Date( new Date(startDate).getFullYear(), new Date(startDate).getMonth(), 1 )).format("YYYY-MM-DD"));
                data.append("EndDate", moment(new Date( new Date(endDate).getFullYear(), new Date(endDate).getMonth()+1, 0 )).format("YYYY-MM-DD"));

                console.log("oneToOne", data)
                sendData(data);
            }
        } else if ( typeSubmit == 'template' ) {
            data.append("file", file);
            console.log("Template", data)
            sendData(data);
        }
    }

    function sendData ( dataSend ){
        const handleReloadData = (status, response) => {
            if (status == 200 || response === 'allGood') {
                setNotificationDetails({
                    title: t("notifyAllCorrect"),
                    type: 'positive',
                    description: ''
                });
                setSelectedChannel([]);
                setSelectedEndUser([]);
                setEndUserList([]);
                setSelectedPress([]);
                setPressList([]);
                setDiscount('');
                setStartDate('');
                setEndDate('');
                setFile('');
                setTimeout(() => { setReloadView(reloadView+1); setShowModal(false); setShowNotification(false); }, 1000);
            } else {
                Swal.fire( "Error " + status, response, "error" );
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setShowNotification(true);
        }
        connectApi.post("api/Channels/uploadPriceProtectionData", dataSend, handleReloadData).catch((error) => { Swal.fire( "Error ", error?.response?.data, "error" ); });
    }

    const [orderBy, setOrderBy] = useState("startDate");
    const [orderType, setOrderType] = useState("descending");
    const [channelFilter, setChannelFilter] = useState("");
    const [endUserFilter, setEndUserFilter] = useState("");
    const [pressFilter, setPressFilter] = useState("");
    const [order, setOrder] = useState([ 'customerName', 'endUserName', 'idPress', 'discount', 'startDate', 'endDate' ]);
    const [currentPage, setCurrentPage] = useState(1);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const pageSize = 20;

    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort ( dataPriceProtection, { customerName: channelFilter, endUserName: endUserFilter, idPress: pressFilter }, orderBy, orderType );
    let pagedData = filteredData.slice( (currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize );
    const handleSort = (_, { id, type }) => { 
        setOrderBy(id);
        setOrderType(type);
    };

    return (<div>
        <Button 
            style={{ position: "absolute", marginTop: "7px", }}
            appearance="success" 
            onClick={() => setShowModal(true)}
            disabled={loadingData}
        >
            {t('addNew')}
        </Button>
        <div>
            <Table
                columns = {[
                    {
                        id: 'customerName',
                        label: t("channel"),
                        filter: (
                            <Search
                                id="channel-filter"
                                value={channelFilter}
                                onChange={(val) => { setChannelFilter(val); setCurrentPage(1); }}
                            />
                        )
                    }, {
                        id: 'endUserName',
                        label: t("endUser"),
                        filter: (
                            <Search
                                id="name-filter"
                                value={endUserFilter}
                                onChange={(val) => { setEndUserFilter(val); setCurrentPage(1);
                                }}
                            />
                        )
                    }, {
                        id: 'idPress',
                        label: t("pressid"),
                        filter: (
                            <Search
                                id="name-filter"
                                value={pressFilter}
                                onChange={(val) => { setPressFilter(val); setCurrentPage(1);
                                }}
                            />
                        )
                    }, {
                        id: 'discount',
                        label: t("priceProtection")
                    }, {
                        id: 'startDate',
                        label: t("specialcondition.startdate")
                    }, {
                        id: 'endDate',
                        label: t("specialcondition.enddate")
                    },
                ]}
                showFilters
                columnReorder
                data={pagedData}
                loading={loadingData}
                onSort={handleSort}
                onColumnReorder={(reOrder) => setOrder(reOrder)}
                preferences={{
                    defaultOrder: order,
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    },
                    order: order
                }}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                }}
            />
            <div style={{ textAlign: "left" }}>
                <Button
                    onClick={()=>{
                        setTimeout(() => {
                        const dataXlsx = filteredData.map((item) => { return item; });
                        const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                        const wb = XLSX.utils.book_new();
                        const date = moment(new Date()).format('YYYYMMDDHHmm');
                        const filename = 'PriceProtection-' + date + '.xlsx';
                        const ws_name = "PriceProtection";
                        XLSX.utils.book_append_sheet(wb, ws, ws_name);
                        XLSX.writeFile(wb, filename);
                        }, 750);
                    }}
                    disabled={filteredData.length === 0}
                    leadingIcon={<IconDownload />}
                    title={t('download data')}
                >
                    {t('download')}
                </Button>
            </div>
        </div>
        <Modal
            id="form-modal"
            onClose={() => { setShowModal(false); }}
            closeButton={true}
            show={showModal}
            title={ "Price Protection" }
            footer={(<>
                {showNotification ? (
                    <div className="show-animated" style={{ marginBottom: '-12px' }}>
                        <InlineNotification
                            title={notificationDetails.title}
                            type={notificationDetails.type}
                            description={notificationDetails.description}
                            onClose={() => { setShowNotification(false) }}
                        /> <br />
                    </div>
                ) : <></>}
                <div className="vn-button-group--responsive">
                    {optionVal == "0" ? (<Button onClick={() => {submitFile('oneToOne');}} >{t('addNew')}</Button>) 
                        : (<Button onClick={() => {submitFile('template');}} disabled={!file} >{t('upload')}</Button>)}
                    <Button appearance="secondary" onClick={() => {setShowModal(false);}}> Close </Button>
                </div>
            </>)}
        >
            <RadioButtons 
                name="radiobutton_default" 
                defaultValue="0" 
                value={optionVal}
                onChange={(x, val) => {setOptionVal(val); setFile('');}}
            >
                <RadioButton value="0" label="Agregar un registro" />
                <RadioButton value="1" label="Agregar Multiples registros" />
            </RadioButtons> <br />
            {optionVal == "0" ? (<>
                <label>{t('channel')}</label>
                <Select
                    options={channelList}
                    value={selectedChannel}
                    placeholder={t('select_channel')}
                    onChange={(e) => {setSelectedChannel([e.value]);fetchEndUsers(e.value);}}
                    onClear={() => {setSelectedChannel([]);setSelectedEndUser([]);setEndUserList([]);setSelectedPress([]);setPressList([]);}}
                /> <br />
                <label>{t('endUserName')}</label>
                <Select
                    options={endUserList}
                    value={selectedEndUser}
                    placeholder={t('selectEndUser')}
                    onChange={(e) => {setSelectedEndUser([e.value]);fetchPressList(e.value);}}
                    onClear={() => {setSelectedEndUser([]);setSelectedPress([]);setPressList([]);}}
                /> <br />
                <label>{t("pressid")}</label>
                <Select
                    options={pressList}
                    value={selectedPress}
                    placeholder={t('pressid')}
                    onChange={(e) => {setSelectedPress([e.value]);}}
                    onClear={() => {setSelectedPress([]);}}
                /> <br />
                <label>{t("discount")}</label>
                <TextBox
                    type='number'
                    step='0.0001'
                    placeholder="0.01234567"
                    value={discount}
                    onChange={(value) => { setDiscount(value); }}
                /> <br />
                <label>{t("specialcondition.startdate")}</label> <label style={{marginLeft:"50px"}}>{t("specialcondition.enddate")}</label>
                <DatePicker
                    calendarOrientation={['up']}
                    endDate={endDate}
                    endDatePlaceholder="mm/dd/yyyy"
                    onChange={handleOnDateChange}
                    range
                    startDate={startDate}
                    startDatePlaceholder="mm/dd/yyyy"
                    blockPastDates //monthYearNavigation //yearsRange={{ start: 2026, end: 2099 }}
                />
            </>) : (<>
                <label>{t('selectFile')}</label>
                <FilePicker 
                    id="Files"
                    accept=".xlsx,.xls,.csv"
                    onChange={(event) => {setFile(event.target.files[0]);}}
                /><br />
                <Button 
                    appearance="secondary" 
                    leadingIcon={<IconDownload />} 
                    onClick={() => {downloadFile("PriceProtectonListTemplate.xlsx");}}
                >
                    {t('downloadTemplate')}
                </Button> <br />
            </>)}
        </Modal>
    </div>);
}

export default PriceProtectionView;
